import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import {
  ErrorSnacktOpen
} from "../../ErrorSnack/actions";
//import { cargarCaracteristicasMod } from "../EditarPrestacionForm/actions";

export const cargarModalObservacion = (openModal, observacion, idPaquete) => ({
  type: "CARGAR_MODAL_OBSERVACION",
  openModal,
  observacion,
  idPaquete,
});

export const CambiarObservacion = (observacion) => ({
  type: "CAMBIAR_OBSERVACION",
  observacion,
});

export const guardarObservacionPaquete = (idPaquete, observacion) => ({
  type: "GUARDAR_OBSERVACION",
  idPaquete,
  observacion,
});


export const cerrarModalObservacion = (cerrar) => ({
  type: "CERRAR_MODAL_OBSERVACION",
  cerrar,
});

export const abrirModalCaracteristicas = (openModal, caracteristicas) => ({
  type: "ABRIR_MODAL_CARACTERISTICAS",
  openModal,
  caracteristicas,
});


export const cerrarModalCaracteristicas = (cerrar) => ({
  type: "CERRAR_MODAL_CARACTERISTICAS",
  cerrar,
});

export const abrirModalDetalle = (openModal, totalClinica, totalHMQ, totalMonto, detalles) => ({
  type: "ABRIR_MODAL_DETALLE",
  openModal,
  totalClinica,
  totalHMQ,
  totalMonto,
  detalles,
});

export const cerrarModalDetalle = (cerrar) => ({
  type: "CERRAR_MODAL_DETALLE",
  cerrar,
});

export const cargarEditarPaquete = (modalEditarPaquete) => ({
  type: "CARGAR_EDITAR_PAQUETE",
  modalEditarPaquete,
});

export const SeleccionarPrestacionEliminar = (idPrestacionEliminar) => ({
  type: "CAMBIAR_PRESTACION_ELIMINAR",
  idPrestacionEliminar,
});

export const SeleccionarPaqueteEditar = (idPaqueteEditar, paquete) => ({
  type: "CAMBIAR_PAQUETE_EDITAR",
  idPaqueteEditar,
  paquete,
});

export const limpiarPaqueteEditar = (paquete) => ({
  type: "LIMPIAR_PAQUETE_EDITAR",
  paquete,
});

export const cargarCaracteristicasMod = (caracteristicas) => ({
  type: "CARGAR_CARACTERISTICAS_MOD",
  caracteristicas,
});

export const cargarDetalleMod = (detalle) => ({
  type: "CARGAR_DETALLE_MOD",
  detalle,
});

export const CambiarCaracteristica = (tipo, descripcion) => ({
  type: "EDIT_PAQUETE/CAMBIAR_CARACTERISTICA",
  tipo,
  descripcion,
});

export const addCaracteristica = (tipo, descripcion) => ({
  type: "EDIT_PAQUETE/NUEVA_CARACTERISTICA",
  tipo,
  descripcion,
});

export const eliminarCaracteristica = (index) => ({
  type: "EDIT_PAQUETE/BORRAR_CARACTERISTICA",
  index,
});

export const eliminarPrestaciones = (prestaciones) => ({
  type: "EDIT_PAQUETE/BORRAR_PRESTACIONES",
  prestaciones,
});

export const CambiarPrestacionesSeleccionadas = (prestacionesSeleccionadasPQ) => ({
  type: "CAMBIAR_PRES_SELECCIONADAS",
  prestacionesSeleccionadasPQ,
});

export const CambiarVigenciaPrestacionEdicion = (vigenciaPrestacionEdicion, error) => ({
  type: "CAMBIAR_VIGENCIA_PRESTACION_EDICION",
  vigenciaPrestacionEdicion,
  error,
});

export const openModalDetallePrestacion = (estado) => ({
  type: "ABRIR_MODAL_DETALLE_PRESTACION",
  estado,
});

export const CargardetallePrestacion = (index) => ({
  type: "CARGAR_DETALLE_PRESTACION_PAQUETE",
  index,
});

export const CargardetalleNuevaPrestacion = () => ({
  type: "CARGAR_DETALLE_NUEVA_PRESTACION",
});

export const GuardardetallePrestacion = (detalle) => ({
  type: "GUARDAR_DETALLE_PRESTACION",
  detalle,
});

export const GuardardetalleNuevaPrestacion = (detalle) => ({
  type: "GUARDAR_DETALLE_NUEVA_PRESTACION",
  detalle,
});

export const CambiarCodigoPaquetePres = (codigoPaquetePres) => ({
  type: "CAMBIAR_CODIGO_PAQUETE_PRES",
  codigoPaquetePres,
});

export const CambiarCodIntervPres = (codigoIntervPres) => ({
  type: "CAMBIAR_CODIGO_INTERVENCION_PRES",
  codigoIntervPres,
});

export const CambiarGlosaPaquetePres = (glosaPaquetePres) => ({
  type: "CAMBIAR_GLOSA_PAQUETE_PRES",
  glosaPaquetePres,
});

export const CambiarGlosaIntervPres = (glosaIntervPres) => ({
  type: "CAMBIAR_GLOSA_INTERVENCION_PRES",
  glosaIntervPres,
});

export const CambiarTipoAtencion = (tipoAtencion) => ({
  type: "CAMBIAR_TIPO_ATENCION",
  tipoAtencion,
});

export const CambiarCodPrestador = (codPrestador) => ({
  type: "CAMBIAR_CODIGO_PRESTACION_PRESTADOR",
  codPrestador,
});

export const CambiarCodIsapre = (codIsapre) => ({
  type: "CAMBIAR_CODIGO_PRESTACION_ISAPRE",
  codIsapre,
});

export const CambiarCodProfesional = (codProf) => ({
  type: "CAMBIAR_CODIGO_PROFESIONAL",
  codProf,
});

export const CambiarGlosaPrestador = (glosa) => ({
  type: "CAMBIAR_GLOSA_PRESTADOR",
  glosa,
});

export const CambiarItemImed = (imed) => ({
  type: "CAMBIAR_ITEM_IMED",
  imed,
});

export const CambiarCantidadPres = (cantidad) => ({
  type: "CAMBIAR_CANTIDAD",
  cantidad,
});

export const CambiarMedicoUHoteleria = (medHot) => ({
  type: "CAMBIAR_MEDICO_HOTELERIA",
  medHot,
});

export const CambiarUnidad = (unidad) => ({
  type: "CAMBIAR_UNIDAD",
  unidad,
});

export const CambiarMonto = (monto) => ({
  type: "CAMBIAR_MONTO",
  monto,
});

export const CambiarRutBono = (rutBono) => ({
  type: "CAMBIAR_RUT_BONO",
  rutBono,
});

export const OpenEliminarPrestacion = () => (dispatch) => {
  dispatch(cargarModalObservacion(true));
};

export const CloseEliminarPrestacion = () => (dispatch) => {
  dispatch(cargarModalObservacion(false));
};

export const OpenEditarPaquete = () => (dispatch) => {
  dispatch(cargarEditarPaquete(true));
};

export const CloseEditarPrestacion = () => (dispatch) => {
  dispatch(cargarEditarPaquete(false));
};

export const GuardarObservacion = (observacion, idPaquete) => (dispatch) => {
  const globalState = store.getState().global;
  fetch(`${apiConfig.apiUri}/v1/paquetes/updateObservacionPaquete`, {
    method: 'POST',
    body: JSON.stringify({
      idPaquete: idPaquete,
      Observacion: observacion,
      token: globalState.token,
    }),
  }).then((res) => res.json().then((result) => {
    //trace.information("updateObservacionPaquete", result);
    dispatch(guardarObservacionPaquete(idPaquete, observacion));
  }), (error) => {
    trace.error("updateObservacionPaquete", error);
    dispatch(ErrorSnacktOpen(
      "Error al cambiar la observacion del paquete",
      error,
    ));
  });
};

export const cargarCaracteristicasPaquetes = (idPaquete, esModal) => (dispatch) => {
  const globalState = store.getState().global;
  fetch(`${apiConfig.apiUri}/v1/paquetes/caracteristicasPaquete`, {
    method: 'POST',
    body: JSON.stringify({
      idPaquete: idPaquete,
      token: globalState.token,
    }),
  }).then((res) => res.json().then((result) => {
    //trace.information("caracteristicasPaquete", result);
    //console.log(result)
    if (esModal === 1) { dispatch(abrirModalCaracteristicas(true, result)) };
    if (esModal === 0) {
      dispatch(abrirModalCaracteristicas(false, result));
      dispatch(cargarCaracteristicasMod(result));
    };
  }), (error) => {
    trace.error("caracteristicasPaquete", error);
    dispatch(ErrorSnacktOpen(
      "Error al cargar las caracteristicas del paquete",
      error,
    ));
  });
};

export const cargarDetallePaquete = (idPaquete, totalClinica, totalHMQ, totalMonto, esModal) => (dispatch) => {
  const globalState = store.getState().global;
  fetch(`${apiConfig.apiUri}/v1/paquetes/prestacionesPaquete`, {
    method: 'POST',
    body: JSON.stringify({
      idPaquete: idPaquete,
      token: globalState.token,
    }),
  }).then((res) => res.json().then((result) => {
    //trace.information("prestacionesPaquete", result);
    //console.log(result)
    if (esModal === 1) { dispatch(abrirModalDetalle(true, totalClinica, totalHMQ, totalMonto, result)) };
    if (esModal === 0) {
      dispatch(abrirModalDetalle(false, totalClinica, totalHMQ, totalMonto, result));
      if (totalClinica != null) {
        dispatch(cargarDetalleMod(result));
      }
    };
  }), (error) => {
    trace.error("prestacionesPaquete", error);
    dispatch(ErrorSnacktOpen(
      "Error al cargar las prestaciones del paquete",
      error,
    ));
  });
};